/**
 * @generated SignedSource<<c648bede09908bc9ce1445740cf18658>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useStatusUpdatesAutomationNudgeAction_content$data = {
  readonly ancestors: ReadonlyArray<{
    readonly id: string | null;
    readonly title: string | null;
  } | null> | null;
  readonly children: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly metadata: {
        readonly createdDate: string | null;
      };
      readonly title: string | null;
    } | null> | null;
  } | null;
  readonly history: {
    readonly ownedBy: {
      readonly accountId?: string | null;
    } | null;
  } | null;
  readonly id: string | null;
  readonly metadata: {
    readonly sourceTemplateEntityId: string | null;
  };
  readonly space: {
    readonly id: string | null;
  } | null;
  readonly title: string | null;
  readonly " $fragmentType": "useStatusUpdatesAutomationNudgeAction_content";
};
export type useStatusUpdatesAutomationNudgeAction_content$key = {
  readonly " $data"?: useStatusUpdatesAutomationNudgeAction_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useStatusUpdatesAutomationNudgeAction_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "title"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useStatusUpdatesAutomationNudgeAction_content",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ]
    },
    {
      "concreteType": "History",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "ownedBy",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "accountId"
                }
              ],
              "type": "KnownUser"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "sourceTemplateEntityId"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 25
        }
      ],
      "concreteType": "PaginatedContentList",
      "kind": "LinkedField",
      "name": "children",
      "plural": false,
      "selections": [
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "concreteType": "ContentMetadata",
              "kind": "LinkedField",
              "name": "metadata",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "createdDate"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "children(first:25)"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "d707711b080a3c76bafcf245c28a37ef";

export default node;
